import React from 'react';

import { CheckboxProps } from './Checkbox.type';

const Checkbox = (props: CheckboxProps) => {
	return (
		<input
			id={props.id}
			name={props.name}
			type={props.type}
			onChange={props.onClick}
			checked={props.isChecked}
		/>
	);
};

export default Checkbox;
